import React, { useEffect, useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  Font,
  Image,
} from "@react-pdf/renderer";
import { format } from "../../App";
import moment from "moment";
import QRCode from "qrcode";
import phetsarath from "../font/PHETSARATH OT.TTF";
import { useSelector } from "react-redux";
import { pad } from "../../data/allfunction";

import {
  cover,
  notpaid,
  paid,
  scanpaid,
  logo,
  checked,
  qrpay,
  carcover,
} from "../../data/pic";

const ip = process.env.REACT_APP_IP;
const QR = process.env.REACT_APP_QR;

Font.register({
  family: "PHETSARATH OT",
  src: phetsarath,
});
const styles = StyleSheet.create({
  page: {
    fontFamily: "PHETSARATH OT",
    // backgroundColor:'pink' ,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 10,
    paddingRight: 10,
  },
  row: {
    flexDirection: "row",
    // backgroundColor: '#E4E4E4',
    marginBottom: 2,
    marginRight: 5,
    marginLeft: 5,
    padding: 5,
    borderWidth: 0.5,
  },
  row_p: {
    flexDirection: "row",
    // backgroundColor: 'red',
    marginBottom: 0,
    marginRight: 5,
    marginLeft: 5,
    padding: 2,
  },
  row_table: {
    flexDirection: "row",
    width: "100%",
    padding: 5,
    borderBottomWidth: 0.3,
    display: "flex",
    // backgroundColor: 'pink'
  },
  row_wrap: {
    flexDirection: "row",
    // backgroundColor: '#E4E4E4',
    marginBottom: 2,
    marginRight: 5,
    marginLeft: 5,
    flexWrap: "wrap",
  },
  rowC: {
    flexDirection: "column",
    // backgroundColor: '#E4E4E4',
    marginBottom: 2,
    marginRight: 5,
    marginLeft: 5,
    padding: 5,
    borderWidth: 0.5,
  },
  rowR: {
    flexDirection: "row",
    marginBottom: 2,
    marginRight: 5,
    marginLeft: 5,
    padding: 5,
    borderWidth: 0.5,
  },
  box: {
    display: "flex",
    flexDirection: "row",
  },
  box_o: {
    flex: 1,
    paddingRight: 5,
    //   flexWrap: 'wrap'
  },
  box_o1: {
    flex: 1,
  },
  box_o2: {
    flex: 5,
  },
  box_c: {
    flexGrow: 0,
    backgroundColor: "#fff",
  },
  box_f: {
    // backgroundColor: 'red',
    width: "100%",
  },
  fontHead: {
    fontSize: 9,
  },
  fontHeadSmall: {
    fontSize: 7,
    paddingLeft: 37,
  },
  fontNalmal: {
    fontSize: 14,
  },
  logo1: {
    width: 100,
    padding: 0,
  },
  ico: {
    width: 15,
    height: 15,
    paddingRight: 3,
  },
  col: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    // backgroundColor:'red'
  },
  col1: {
    flex: 4,
    paddingLeft: 5,
  },
  col2: {
    flex: 5,
    alignItems: "flex-end",
    paddingRight: 5,
  },
  col3: {
    flex: 1,
    alignItems: "flex-end",
    //  paddingRight: 5
  },
  col4: {
    // flex: 2,
    alignItems: "flex-end",
    paddingRight: 5,
  },
  info: {
    position: "absolute",
    left: 55,
    bottom: 10,
    fontSize: 9,
  },

  qrCar: {
    width: 50,
    height: 50,
    // position: 'absolute',
    // left: 5,
    // bottom: 10,
  },
  qr: {
    width: 40,
    height: 40,
    position: "absolute",
    left: 5,
    bottom: 10,
  },
  qrpack: {
    width: 40,
    height: 40,
    position: "absolute",
    left: 290,
    bottom: 10,
    color: "red",
  },
});

const D = (props) => {
  //   var remark = [];
  let { img, no, user, pack, pacagesQR } = props;
  console.log("pack");
  console.log(pack);

  //   try {
  //     remark = Object.values(JSON.parse(pack.detail));
  //     console.log(201);
  //     console.log(remark);
  //   } catch (error) {}

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.row}>
          <View style={styles.box_o}>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-evenly",
              }}
            >
              <Text style={{ fontSize: 12, color: "red", paddingRight: 10 }}>
                E-NO: {pad(no.no)}
              </Text>
              <View
                style={{
                  display: "flex",
                  alignItems: "center",
                  paddingRight: 10,
                }}
              >
                <Text style={styles.fontHead}>ໃບຢັ້ງຢືນປະກັນໄພຍານພາຫະນະ</Text>
                <Text style={{ fontSize: 7 }}>
                  MOTOR VEHICLE INSURANCE SCEDULE
                </Text>
              </View>
              <Image src={logo} style={styles.logo1} />
            </View>
            <Text style={styles.fontHead}>
              ຊື່ ແລະ ນາມສະກຸນ/Name {"&"} Surname: {no.o_name}
            </Text>
            <Text style={styles.fontHead}>ທີ່ຢູ່/ Address: {no.o_address}</Text>
            <Text style={styles.fontHead}>
              ໂທລະສັບ/ Phone:{no.o_tel} ; ປະເພດລົດ/ Vehicle type:{no.o_type}
            </Text>
            <Text style={styles.fontHead}>
              ຫຍີ່ຫໍ້/ Make:{no.o_make} ; ເລກທະບຽນ/Plate No:{no.o_plate}
            </Text>
            <Text style={styles.fontHead}>
              ສີລົດ/ Color:{no.o_color} ; ຄວາມແຮງ/ Power CC:{no.o_power}
            </Text>
            <Text style={styles.fontHead}>
              ເລກຈັກ/Engine No:{no.o_engine}; ເລກຖັງ/ Chassis No:{no.o_chassis}
            </Text>
            <Text style={styles.fontHead}>
              ນ້ຳໜັກ/ Wheight: {no.o_weight} ໂຕນ/Ton; ຈຳນວນບ່ອນນັ່ງ/ Seats:{" "}
              {no.o_seats}
            </Text>
          </View>

          <View
            style={{
              paddingLeft: 0,
              borderWidth: 0.5,
              borderRadius: 7,
              padding: 7,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-evenly",
              }}
            >
              <Image src={logo} style={{ width: 70 }} />
              <View
                style={{
                  display: "flex",
                  alignItems: "center",
                  paddingRight: 0,
                }}
              >
                <Text style={{ fontSize: 8 }}>ໃບຢັ້ງຢືນປະກັນໄພຍານພາຫະນະ</Text>
                <Text style={{ fontSize: 5 }}>
                  MOTOR VEHICLE INSURANCE SCEDULE
                </Text>
                <Text style={{ fontSize: 10, color: "red", paddingRight: 5 }}>
                  E-NO: {pad(no.no)}
                </Text>
              </View>
            </View>
            <Text style={styles.fontHead}>
              *ໄລຍະການຄຸ້ມກັນ/ Period of Cover
            </Text>
            <Text style={styles.fontHead}>
              {" "}
              {"   "}-ເລີ່ມແຕ່/ From:{" "}
              {moment(no.start).format("DD/MM/YYYY HH:mm:ss")}
            </Text>
            <Text style={styles.fontHead}>
              {" "}
              {"   "}-ເຖິງ/ To: {moment(no.end).format("DD/MM/YYYY HH:mm:ss")}
            </Text>
            <Text style={styles.fontHead}>
              *ເລກທະບຽນລົດ/ Plate: {no.o_plate}
            </Text>
            <Text style={styles.fontHead}>*ການຄຸ້ມກັນ/ Cover: {no.cover}</Text>
            <Text style={styles.fontHead}>
              Claim Hotline 24Hr : 020 5799 9922-33
            </Text>
          </View>
        </View>
        <View style={styles.rowC}>
          <View style={styles.box_f}>
            <Text style={styles.fontHead}>
              ພາກທີ່1:ການປະກັນໄພລົດທາງແພ່ງຕໍ່ບຸກຄົນທີສາມ/ Part 1: Motor Vehicle
              Third Party Liability Insurance.
            </Text>
            <View
              style={{
                flexDirection: "row",
                marginBottom: 2,
                marginRight: 5,
                marginLeft: 5,
                flexWrap: "wrap",
              }}
            >
              {no.a_used === "private" ? (
                <>
                  <Image src={checked} style={styles.ico} />
                  <Text style={styles.fontHead}> ລົດສ່ວນໂຕ/ Private </Text>
                </>
              ) : (
                <>
                  <Image src={checked} style={styles.ico} />
                  <Text style={styles.fontHead}> ຮັບຈ້າງ/ Business </Text>
                </>
              )}

              {no.a_type === "new" ? (
                <>
                  <Image src={checked} style={styles.ico} />
                  <Text style={styles.fontHead}> ສັນຍາໃໝ່/ New</Text>
                </>
              ) : (
                <>
                  <Image src={checked} style={styles.ico} />
                  <Text style={styles.fontHead}>ຕໍ່ສັນຍາ/ Renewal </Text>
                </>
              )}
            </View>
          </View>
        </View>

        <View style={styles.rowR}>
          <View
            style={styles.box_o2}
            // style = {{flex:5}}
          >
            <View style={styles.box_f}>
              <Text
                style={{ ...styles.fontHead, color: "red", fontWeight: "bold" }}
              >
                ລາຍລະອຽດການຄຸ້ມກັນ/Option: {no.cover}
              </Text>
              <View style={styles.row_table}>
                <View style={styles.col1}>
                  <Text style={styles.fontHead}>
                    ຂອບເຂດການຄຸ້ມກັນ ແລະ ທາງເລືອກ
                  </Text>
                </View>
                <View style={styles.col4}>
                  <Text style={styles.fontHead}>
                    ວົງເງິນຄຸ້ມກັນສູງສຸດ/Cover
                  </Text>
                </View>
              </View>
              <View style={styles.row_table}>
                <View style={styles.col1}>
                  <Text style={styles.fontHead}>
                    {/* 1. {pack.id >= 19 && pack.id <= 29 ?
                                            'ເນື່ອງຈາກອຸປະຕິເຫດທຸກຢ່າງ'
                                            :
                                            'ຕຳກັບພາຫະນະອື່ນ'
                                        }, ໄຟໃໝ້, ລະເບີດ ຫຼື ຖືກລັກໝົດຄັນ */}
                    1. {pack.cover_type}
                  </Text>
                  <Text style={styles.fontHead}>
                    {" "}
                    {"  "}
                    {"  "}
                    {"  "}- ພາກສ່ວນຫົວລາກ/Head{" "}
                  </Text>
                  <Text style={styles.fontHead}>
                    {" "}
                    {"  "}
                    {"  "}
                    {"  "}- ພາກສ່ວນຫາງລາກ/Trailer
                  </Text>
                  <Text style={styles.fontHead}>
                    {" "}
                    {"  "}- ຄ່າໃຊ້ຈ່າຍຍົກ ຫຼື ລາກແກ່ 20% ຂອງມູນຄ່າສ້ອມແປງສູງສຸດ
                  </Text>
                  <Text style={styles.fontHead}>
                    {" "}
                    {"  "} Hosting or Towing cost 20% of own car damage max
                  </Text>
                </View>
                <View style={styles.col4}>
                  <Text style={styles.fontHead}>{format(pack.owner)}</Text>
                  <Text style={styles.fontHead}>
                    {pack.truck_head == null ? " - " : format(pack.truck_head)}
                  </Text>
                  <Text style={styles.fontHead}>
                    {pack.truck == null ? " - " : format(pack.truck)}
                  </Text>
                  <Text style={styles.fontHead}>
                    {format(pack.carryVehicle)}
                  </Text>
                </View>
              </View>
              <View style={styles.row_table}>
                <View style={styles.col1}>
                  <Text style={styles.fontHead}>
                    2. ຄວາມຮັບຜິດຊອບທາງແພ່ງຕໍ່ບຸກຄົນທີສາມ/ Third Party Liability
                    Cover A/B
                  </Text>
                  <Text style={styles.fontHead}>
                    {" "}
                    {"  "}- ຄວາມເສຍຫາຍທາງດ້ານຮ່າງກາຍ ສູງສຸດອຸປະຕິເຫດ 1ຄັ້ງ/
                    Bodily injury, Max per accident
                  </Text>
                  <Text style={styles.fontHead}>
                    {" "}
                    {"  "}- ເສຍຊີວິດຫຼືພິການຖາວອນ/ Death or Total permanent
                    Disability, per person
                  </Text>
                  <Text style={styles.fontHead}>
                    {" "}
                    {"  "}- ຄ່າປິ່ນປົວສູງສຸດ/ຄົນ/ Medical expenses, max person
                  </Text>
                  <Text style={styles.fontHead}>
                    {" "}
                    {"  "}- ໃນນັ້ນຄ່ານອນໂຮງໝໍ/ Of which Hospitalization
                    allowance
                  </Text>
                  <Text style={styles.fontHead}>
                    {" "}
                    {"  "}- ຄວາມເສຍຫາຍທາງດ້ານວັດຖຸ,ສູງສຸດ/ອຸປະຕິເຫດ1ຄັ້ງ/
                    Material Damages, Max per accident{" "}
                  </Text>
                </View>
                <View style={styles.col4}>
                  <Text style={styles.fontHead}> </Text>
                  <Text style={styles.fontHead}>{format(pack.bodily)}</Text>
                  <Text style={styles.fontHead}>{format(pack.death)}</Text>
                  <Text style={styles.fontHead}>{format(pack.medical)}</Text>
                  <Text style={styles.fontHead}>
                    {format(pack.hospitalization)}
                  </Text>
                  <Text style={styles.fontHead}>{format(pack.material)}</Text>
                </View>
              </View>
              <View style={styles.row_table}>
                <View style={styles.col1}>
                  <Text style={styles.fontHead}>3. ຜູ້ຂັບຂີ່/ Driver</Text>
                  <Text style={styles.fontHead}>
                    {" "}
                    {"  "}- ເສຍຊີວິດຫຼືພິການຖາວອນທັງໝົ້ດ, ສູງສຸດ/ຄົນ/ Death or
                    Total permanent Disability, per person
                  </Text>
                  <Text style={styles.fontHead}>
                    {" "}
                    {"  "}- ຄ່າປິ່ນປົວສູງສຸດ/ຄົນ/ Medical expenses, max per
                    person
                  </Text>
                </View>
                <View style={styles.col4}>
                  <Text style={styles.fontHead}> </Text>
                  <Text style={styles.fontHead}>
                    {format(pack.death_driver)}
                  </Text>
                  <Text style={styles.fontHead}>
                    {format(pack.medical_driver)}
                  </Text>
                </View>
              </View>
              <View style={styles.row_table}>
                <View style={styles.col1}>
                  <Text style={styles.fontHead}>
                    {" "}
                    {"  "}ການປົກປ້ອງສິດສຸງສຸດ/ອຸປະຕິເຫດ 1 ຄັ້ງ/ Defense H, Max
                    per accident
                  </Text>
                </View>
                <View style={styles.col4}>
                  <Text style={styles.fontHead}>{format(pack.h)}</Text>
                </View>
              </View>
            </View>
          </View>
          <View style={styles.box_o1}>
            <View style={styles.col}>
              <Image src={pacagesQR} style={styles.qrCar} />
              <Text style={styles.fontHead}>ລາຍລະອຽດການຄຸ້ມກັນ</Text>
              <Text style={styles.fontHead}>Detail of Cover</Text>
              <Image src={cover} style={{ width: 45 }} />
            </View>
          </View>
          {/* <View style={styles.col}>
                            <Image src={qrpay} style={styles.qrCar} />
                            <Text style={styles.fontHead}>
                                ສະແກນເພື່ອຈ່າຍເງິນ
                            </Text>
                        </View> */}
          {/* </View> */}
        </View>
        <View style={{ ...styles.rowR, ...{ paddingVertical: 0 } }}>
          <View style={styles.box_o2}>
            <View
              style={{
                flexDirection: "column",
                marginBottom: 2,
                marginRight: 5,
                marginLeft: 5,
                // padding: 5,
                //  borderWidth:1
              }}
            >
              <View style={styles.row_p}>
                <View style={styles.col3}>
                  <Text style={styles.fontHead}>
                    ຄ່າທຳນຽມປະກັນໄພ ບໍ່ທັນລວມອາກອນ/ Net Premium{" "}
                  </Text>
                </View>
                <View style={styles.col3}>
                  <Text style={styles.fontHead}>{format(no.premuim)}</Text>
                </View>
              </View>
              <View style={styles.row_p}>
                <View style={styles.col3}>
                  <Text style={styles.fontHead}>ອາກອນມູນຄ່າເພີ່ມ/ VAT</Text>
                </View>
                <View style={styles.col3}>
                  <Text style={styles.fontHead}>{format(no.vat)}</Text>
                </View>
              </View>
              <View style={styles.row_p}>
                <View style={styles.col3}>
                  <Text style={styles.fontHead}>ຄ່າຂື້ນທະບຽນ/ Register</Text>
                </View>
                <View style={styles.col3}>
                  <Text style={styles.fontHead}>{format(no.register)}</Text>
                </View>
              </View>
              <View style={styles.row_p}>
                <View style={styles.col3}>
                  <Text style={styles.fontHead}>
                    ລວມມູນຄ່າຕ້ອງຈ່າຍ/ Total premium to be paid
                  </Text>
                </View>
                <View style={styles.col3}>
                  <Text style={styles.fontHead}>
                    {format(no.total_premuim)}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          <View style={{ ...styles.box_o1 }}>
            <View style={styles.col}>
              <Image src={qrpay} style={styles.qrCar} />
              <Text style={styles.fontHead}>ສະແກນເພື່ອຈ່າຍເງິນ</Text>
              <Image src={scanpaid} style={{ width: 40 }} />
            </View>
          </View>
        </View>
        <View style={styles.rowR}>
          <View style={styles.box_o2}>
            <Text style={styles.fontHead}>ສະຖານະການຊຳລະ</Text>
          </View>
          <View style={styles.box_o2}>
            {no.emp_paid === 1 ? (
              <Image src={paid} style={{ width: 85 }} />
            ) : (
              <Image src={notpaid} style={{ width: 160 }} />
            )}
          </View>
        </View>
        <View style={styles.row_p}>
          <View style={{ flex: 1, alignItems: "center" }}>
            <Text
              style={{ ...styles.fontHead, color: "red", fontWeight: "bold" }}
            >
              ເລີ່ມຄຸ້ມກັນ/ From::{" "}
              {moment(no.start).format("DD/MM/YYYY HH:mm:ss")}{" "}
            </Text>
          </View>
          <View style={{ flex: 1, alignItems: "center" }}>
            <Text
              style={{ ...styles.fontHead, color: "red", fontWeight: "bold" }}
            >
              ວັນສິ້ນສຸດ/ To:: {moment(no.end).format("DD/MM/YYYY HH:mm:ss")}{" "}
            </Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            marginBottom: 0,
            marginRight: 5,
            marginLeft: 5,
            padding: 5,
          }}
        >
          {/* <View style={{ flex: 1, alignItems: 'center' }} >
                        <Text style={styles.fontHead}>ຜູ້ໃດ້ຮັບປະກັນໄພ</Text>
                    </View> */}
          <View style={{ flex: 1, alignItems: "center" }}>
            <Text style={styles.fontHead}> </Text>
            <Text style={styles.fontHead}>ຜູ້ອອກສັນຍາ/ Underwriter</Text>
            <Text style={styles.fontHead}>{no.userText}</Text>
          </View>
          <View style={{ flex: 1, alignItems: "center" }}>
            <Text style={styles.fontHead}>
              {" "}
              ສັນຍາສະບັບນີ້ ອອກເມື່ອວັນທີ:{" "}
              {moment(no.dateadd).format("DD/MM/YYYY HH:mm:ss")}
            </Text>
            {/* <Text>  {moment(no.dateadd).isBefore('2022-02-20') ? 'ບໍ່ມີ 10 ເປີເຊັນ' : 'ມີ 10 ເປີເຊັນ'}</Text> */}
            <Text style={styles.fontHead}>
              ບໍລິສັດ ຈົງຈີປະກັນໄພ ຈຳກັດ ຜູ້ດຽວ
            </Text>
            <Text style={styles.fontHead}>
              Zhongji Insurance Sole Co.,ltd(ZJI)
            </Text>
            {
              no.cancel === 1 ? (
                <Text style={{ fontSize: 10, color: "red" }}>
                  ສັນຍາສະບັບນີ້ ຖືກຍົກເລີກ{" "}
                  {no.cancel_date &&
                    moment(no.cancel_date).format("DD/MM/YYYY HH:mm:ss")}{" "}
                </Text>
              ) : null // <Image src={stam} style={{ width: 195 }} />
            }
          </View>
        </View>

        <View
          style={{
            flexDirection: "column",
            marginBottom: 0,
            marginRight: 5,
            marginLeft: 5,
            padding: 5,
          }}
        >
          <Text style={{ fontSize: 8 }}>ຂໍ້ຍົກເວັ້ນ/ Attention</Text>
          <Text style={styles.fontHeadSmall}>
            1.
            ສັນຍາສະບັບນີ້ຈະບໍ່ຄຸ້ມກັນການເສຍຫາຍທີ່ເກີດຈາກຜູ້ຂັບຂີ່ທີ່ບໍ່ມີໃບຂັບຂີ່ຖືກຕ້ອງຕາມປະເພດລົດ
            ຫຼື ຂັບຂີ່ດ້ວຍຄວາມມຶນເມົາຈາກການດື່ມເຫຼົ້າ ຫຼື ຢາເສບຕິດ ຫຼື
            ບໍ່ໄດ້ຮັບອະນຸຍາດຈາກຜູ້ໄດ້ຮັບການປະກັນໄພ/ This policy does not cover
            damage caused by driver without driving license or driving under the
            influence of alcohol or drug or without consent of the insurer.
          </Text>
          <Text style={styles.fontHeadSmall}>
            2. ສຳລັບລົດຈັກ, ຜູ້ຂັບຂີ່ ແລະ ຜູ້ຊ້ອນທ້າຍ ຕ້ອງໃສ່ໝວກກັນກະທົບ/ For
            the motorcycle, driver and passenger must wear a crash helmet to be
            indemnified under the “Driver and passenger” cover.
          </Text>
          <Text style={styles.fontHeadSmall}>
            3. ຄວາມຮັບຜິດຊອບຕໍ່ບຸກຄົນທີສາມ ຈະບໍ່ຄຸ້ມກັນການເສຍຫາຍທາງດ້ານຮ່າງກາຍ
            ແລະ ວັດຖຸ, ຊັບສິນຂອງຜູ້ໄດ້ຮັບການປະກັນໄພ/ The third party liability
            cover does not cover damages incurred to the insured and property of
            the insured.
          </Text>
          <Text style={styles.fontHeadSmall}>
            4. ທຸກໆຄວາມເສຍຫາຍທີ່ເກີດຈາກການກໍ່ການຮ້າຍ ຈະບໍ່ໄດ້ຮັບການຄຸ້ມກັນ/ Any
            loss of damage caused by an act of terrorism is excluded.
          </Text>
          <Text style={styles.fontHeadSmall}>
            5. ສັນຍາສະບັບນີ້ຈະບໍ່ຄຸ້ມກັນຄວາມເສຍຫາຍຈາກ
            ການຍັກຍ້ອກສໍ້ໂກງພາຍໄຕ້ສັນຍາເຊົ່າ, ຊື້-ຂາຍຜ່ອນ, ມັດຈຳ
            ດ້ວຍບຸກຄົນທີ່ມີສ່ວນພົວພັນໃນສັນຍາ ດັ່ງກ່າວ/ This policy does not
            cover loss or damage cause by embezzlement under cause by an act of
            terrorism is excluded.
          </Text>
          <Text style={styles.fontHeadSmall}>
            6. ກໍລະນີເກີດອຸປະຕິເຫດ, ຜູ້ໄດ້ຮັບການປະກັນໄພຕ້ອງແຈ້ງໃຫ້ບໍລິສັດ ຈົງຈີ
            ປະກັນໄພ (ZJI) ຮັບຮູ້ທັນທີ ໂທ: 020 57999922/ 020 57999933/ In case of
            accident the insured must notify immediately Zhongji Insurance
            Company (ZJI) Call: 020 57999922/ 020 57999933.
          </Text>
          <Text style={styles.fontHeadSmall}>
            7. ZJI ຈະບໍ່ຮັບຜິດຊອບທຸກໆການທົດແທນຄ່າເສຍຫາຍຕໍ່ຄູ່ກໍລະນີ
            ໂດຍທີ່ບໍ່ໄດ້ມີການຕົກລົງຈາກ ZJI/ ZJI will not be liable to any
            agreement between the insured and the third parties without the
            consent of ZJI.
          </Text>
          <Text style={{ ...styles.fontHeadSmall }}>
            8. ສັນຍາສະບັບນີ້ຈະມີຜົນນໍາໃຊ້ກໍ່ຕໍ່ເມືອ ZJI
            ໄດ້ຮັບຄ່າທໍານຽມປະກັນໄພຄົບຖ້ວນ/ The insurance shall be effective upon
            the receipt of full premium payment.
          </Text>
        </View>

        {/* <Image src={pacagesQR} style={{
                    width: 40,
                    height: 40,
                    position: 'absolute',
                    left: 290,
                    bottom: 10,
                    color: 'red'
                }} />
                <Text
                    style={{
                        fontSize: 8,
                        position: 'absolute',
                        left: 330,
                        bottom: 10,
                        color: 'red'
                    }}
                >
                    ສະແກນຄິວອາໂຄດເພື່ອເບິ່ງຂໍ້ຍົກເວັນການຄຸ້ມກັນສຳຫຼັບແພັກແກັດ
                </Text> */}

        <Image src={img} style={styles.qr} />
        <Text style={styles.info}>
          ຜູ້ສ້າງ {JSON.stringify(user)} ເມື່ອວັນທີ{" "}
          {moment(Date.now()).format("DD/MM/YYYY HH:mm:ss")}
        </Text>

        {/* <Text>{img}</Text> */}
      </Page>
    </Document>
  );
};

const generateQR = async (text) => {
  try {
    const url = await QRCode.toDataURL(text);
    return url;
  } catch (err) {
    return err;
  }
};
// Create Document Component
const MakeDocSafty = (props) => {
  const { user } = useSelector((state) => {
    return state.user;
  });

  let { no, oneData } = props;
  // console.log(no)
  const [dataPackgage, setdataPackgage] = useState({});
  //  const [imgsvg, setimgsvg] = useState('')
  // useEffect(() => {
  // setimgsvg(generateQR(`${QR + no}`))
  // if (no) {
  //     packages(oneData.cover)
  // }
  // }, [no])

  const [imgsvg, setimgsvg] = useState(generateQR(`${QR + no}`));
  // let pacagesQR = process.env.REACT_APP_QR_PACKAGE
  const [pacagesQR, setpacagesQR] = useState(process.env.REACT_APP_QR_PACKAGE);
  useEffect(async () => {
    setimgsvg(await generateQR(`${QR + no}`));
    if (no) {
      packages(oneData.cover);
      // setpacagesQR(
      //     await generateQR(
      //         process.env.REACT_APP_QR_PACKAGE + oneData.cover
      //     ))
    }
  }, [no]);

  async function packages(pack) {
    let link = `${ip}sell_online/packagesOne/${pack}`;
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(link, requestOptions)
      .then((response) => response.json())
      .then(async (result) => {
        // console.log('makedocsafety 558')
        //  console.log(result)
        setdataPackgage(result.data.data[0]);

        // console.log('result.data.data[0].remark_id' + 614)
        // console.log(result.data.data[0].id)
        setpacagesQR(
          await generateQR(
            process.env.REACT_APP_QR_PACKAGE + result.data.data[0].id
          )
        );
      })
      .catch((error) => console.log("error", error));
  }

  if (dataPackgage.id) {
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{ width: "100%", backgroundColor: "#3B9A9C", display: "flex" }}
        >
          <PDFViewer showToolbar style={{ width: "100%", height: 1000 }}>
            <D
              user={user}
              img={imgsvg}
              no={oneData}
              pack={dataPackgage}
              pacagesQR={pacagesQR}
            />
          </PDFViewer>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default MakeDocSafty;
